import BaseSettingsManager from './base-settings-manager.js';

const supportedTemplates = [
  'pure-dark',
  'dark',
  'light',
  'green',
  'flip-blue',
  'flip-red',
  'flip-orange',
  'flip-yellow',
  'flip-purple',
  'flip-pink'
];

function getFlipState() {
  const clock = window.flipClock;
  if (clock && typeof clock.getSettings === 'function') {
    const state = clock.getSettings();
    return {
      is24Hour: state.is24Hour,
      showSeconds: state.showSeconds,
      showDateYear: state.showDateYear
    };
  }
  return {
    is24Hour: localStorage.getItem('flip-clock-24hour') !== 'false',
    showSeconds: localStorage.getItem('flip-clock-seconds') !== 'false',
    showDateYear: localStorage.getItem('flip-clock-date') === 'true'
  };
}

export default class FlipSettingsManager extends BaseSettingsManager {
  constructor() {
    super({
      pageType: 'flip',
      supportedTemplates,
      getCurrentSettings: () => getFlipState(),
      onFormatToggle: () => {
        const clock = window.flipClock;
        if (clock && typeof clock.toggle24Hour === 'function') {
          clock.toggle24Hour();
        }
      },
      onSecondsToggle: () => {
        const clock = window.flipClock;
        if (clock && typeof clock.toggleSeconds === 'function') {
          clock.toggleSeconds();
        }
      },
      onDateToggle: () => {
        const clock = window.flipClock;
        if (clock && typeof clock.toggleDateYear === 'function') {
          clock.toggleDateYear();
        }
      },
      onTemplateSelect: (template) => {
        if (window.templateManager && typeof window.templateManager.setTemplate === 'function') {
          window.templateManager.setTemplate(template);
        }
      }
    });
  }
}
